import { TemplateStruct } from "@/models/Blocks/Itens/Types/template-struct";
import { CalcStructMobile } from "@/models/Social/social-calc-struct-mobile";
import { BlockStruct } from '@/models/Blocks/block-struct';
import { HistoryPosition } from '@/models/Blocks/history-position';
import { MD5 } from '@/models/identify';
import request from '@/Utilities/httpRequest';

export class SocialPosts{
    protected _structs: Array<TemplateStruct> = [];
    protected _nextpage: number|null = 1;
    protected _url: string;
    protected _key: string;
    protected _isMobile: boolean = true;
    protected _params: any;
    protected _isLoading: boolean = false;

    public constructor(url: string, params: any) {
        this._url = url;
        this._params = params;
        this._key = MD5.generation(JSON.stringify(params));
    }

    public get structs(): Array<TemplateStruct>{
        if(this._isLoading){
            let l = new BlockStruct(this.templateBlocks,[]);
            l.skeleton = true;
            return [...this._structs,l.getStruct()];
        }
        return this._structs;
    }

    public isEmpty(): Boolean {
        return this._structs.length === 0 && this._nextpage === null;
    }

    public getData(): Array<TemplateStruct>{
        return this.structs;
    }

    get templateBlocks(): string {
        return this._isMobile ? 'SOCIALMOBILE' : 'SOCIALDESKTOP';
    }

    public async nextPage() {
        if(this._isLoading){
            return false;
        }
        if(this._url && this._nextpage){
            this._isLoading = true;
            let params = this._params;
            let { data } = await request.post(this._url,{...params,...{page: this._nextpage}},false);
            let elements = data.elements ?? [];
            let nextpage = data.nextpage ?? null;
            if(elements.length){
                this._addBlock(elements);
                this._nextpage = nextpage;
            }else{
                this._nextpage = null;
            }
            this._isLoading = false;
        }
    }

    protected _addBlock(value: Array<object>): boolean{
        let key: string|undefined = undefined;

        //Calc to save position on page
        if(this._nextpage){
            key = `${this._key}${HistoryPosition.pageNumSplit()}${this._nextpage}`;
            HistoryPosition.getInstance(key).pageNumber = this._nextpage;
        }

        let calc: CalcStructMobile  =  new CalcStructMobile(value, key, 'PDP_SOCIAL');
        let struct = calc.getStruct();

        if(struct){
            this._structs.push(struct);
            return true;
        }
        return false;
    }
}